/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventfieldcategory2Inputs */

const en_eventfieldcategory2 = /** @type {(inputs: Eventfieldcategory2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category`)
};

const de_eventfieldcategory2 = /** @type {(inputs: Eventfieldcategory2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategorie`)
};

/**
* | output |
* | --- |
* | "Category" |
*
* @param {Eventfieldcategory2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventfieldcategory2 = /** @type {((inputs?: Eventfieldcategory2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventfieldcategory2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventfieldcategory2(inputs)
	return de_eventfieldcategory2(inputs)
});
export { eventfieldcategory2 as "eventFieldCategory" }